import { NgClass } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  forwardRef,
  inject,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  FormGroup,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';
import { MultiSelectModule } from 'primeng/multiselect';

@Component({
  selector: 'finxone-platform-workflow-finx-multiselect',
  templateUrl: './workflow-finx-multiselect.component.html',
  styleUrls: ['./workflow-finx-multiselect.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => WorkflowFinxMultiselectComponent),
      multi: true,
    },
  ],
  standalone: true,
  imports: [MultiSelectModule, ReactiveFormsModule, NgClass, FormsModule],
})
export class WorkflowFinxMultiselectComponent<T> implements OnInit, ControlValueAccessor {
  private cd = inject(ChangeDetectorRef);

  @Input() label: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() options: any[] = [];
  @Input() optionLabel: string;
  @Input() id: string;
  @Input() optionValue: string;
  @Input() optionDisabled: string;
  @Input() formControlName: string;
  @Input() defaultLabel = '';
  @Input() formGroup: FormGroup;
  @Input() isGroup = false;
  @Input() isSearchActive = false;
  @Input() appendto = '';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() value: T[] = [];
  @Input() selectionLimit: number;
  @Input() placeholder!: string;
  @Input() isVerticalAligned = true;

  public readonly inputStringControl = new FormControl();
  // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-empty-function
  onModelChange: Function = () => {};
  // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-empty-function
  onModelTouched: Function = () => {};
  formControlStatus: boolean;
  @Output() valueSelectedEvent = new EventEmitter<T[]>();

  get selectedItems() {
    return this.formGroup?.get(this.formControlName) as FormControl;
  }
  ngOnInit(): void {
    this.inputStringControl.valueChanges.subscribe((inputString) => {
      this.onModelChange(inputString);
      this.onModelTouched();
      this.cd.detectChanges();
    });
    if (this.formGroup && this.formControlName) {
      const formControl = this.formGroup.get(this.formControlName);
      if (formControl) {
        this.inputStringControl.setValue(formControl.value);
        this.formControlStatusValue();
      }
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange(event: any) {
    this.value = event.value;
    this.valueSelectedEvent.emit(event.value);
  }

  writeValue(value: string[]): void {
    value = value ?? '';
    this.inputStringControl?.setValue(value);
    this.cd.markForCheck();
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  registerOnChange(fn: Function): void {
    this.onModelChange = fn;
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  registerOnTouched(fn: Function): void {
    this.onModelTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.inputStringControl.disable();
    } else {
      this.inputStringControl.enable();
    }
    this.cd.markForCheck();
  }

  // This method updates the formControlStatus based on the validity of the associated form control.
  formControlStatusValue() {
    if (this.formGroup && this.formControlName) {
      const formControl = this.formGroup.get(this.formControlName);
      this.formControlStatus = formControl ? formControl.invalid : false;
    }
  }
}
